var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{attrs:{"id":"leaderboard"}},[_c('h',[_vm._v("Today's Rankings")]),_vm._l((_vm.ordered_today_data),function(ref,idx){
var qa_name = ref[0];
var img_count = ref[1];
return _c('div',{key:idx},[_vm._v(" "+_vm._s(qa_name)+": "+_vm._s(img_count)+" ")])})],2)])}
var staticRenderFns = []

export { render, staticRenderFns }